<template>
  <!-- 组装拆分模板 -->
  <div class="make-up-template-list">
    <list-page>
      <search-condition @search="resetSearch" :show-search="true">
        <template #default>
          <el-input v-model="searchInfo.searchKey" placeholder="模板名称" @keydown.enter="resetSearch">
            <template #prefix>模板名称</template>
          </el-input>
          <el-select v-model="searchInfo.status" placeholder="请选择状态" clearable>
            <template #prefix>状态</template>
            <el-option label="启用" :value="1"/>
            <el-option label="停用" :value="0"/>
          </el-select>
        </template>
        <template #option>
          <page-button type="read" el-type="primary" @click="resetSearch">查询</page-button>
          <page-button type="write" el-type="success" @click="$router.push('/stock/makeUp/template/detail')">新建模板</page-button>
        </template>
      </search-condition>
      <list-table>
        <yq-table :data="dataList" height="100%" stripe border page-name="makeUpTemplateList">
          <yq-table-column label="模板名称" prop="templateName" min-width="200rem">
            <template v-slot="{row}">
              <a @click="toDetail(row)">{{row.templateName}}</a>
            </template>
          </yq-table-column>
          <yq-table-column label="出库商品" prop="outDesc" min-width="260rem" :show-overflow-tooltip="true">
            <template v-slot="{row}">
              <span class="muted">{{row.outDesc}}</span>
            </template>
          </yq-table-column>
          <yq-table-column label="入库商品" prop="inDesc" min-width="200rem" :show-overflow-tooltip="true">
            <template v-slot="{row}">
              <span class="muted">{{row.inDesc}}</span>
            </template>
          </yq-table-column>
          <yq-table-column label="状态" prop="status" width="120rem" align="center">
            <template v-slot="{row}">
              <el-tag size="small" :type="row.status === 1 ? 'success' : 'info'">{{row.status === 1 ? '启用' : '停用'}}</el-tag>
            </template>
          </yq-table-column>
          <yq-table-column label="创建时间" prop="createdTime" width="180rem" class-name="muted"/>
          <yq-table-column label="操作" prop="options" :align="'center'" fixed="right" width="120rem" :show-overflow-tooltip="false">
            <template v-slot="{row}">
              <table-button-group label="更多操作">
                <table-button type="write" @click="toDetail(row)">编辑</table-button>
                <table-button type="write" @click="updateStatus(row)">{{row.status === 1 ? '停用' : '启用'}}</table-button>
                <table-button type="delete" el-type="danger" message="是否确认删除该模板" @click="toDelete(row)">删除</table-button>
              </table-button-group>
            </template>
          </yq-table-column>
        </yq-table>
      </list-table>
      <form-page v-model:page-number="searchInfo.pageNumber" v-model:page-size="searchInfo.pageSize"
                 :total-count="searchInfo.totalCount" @onLoad="queryList"/>
    </list-page>
  </div>
</template>

<script>
import ListPage from "@/components/h5/layout/ListPage.vue";
import ListTable from "@/components/h5/layout/ListTable.vue";
import SearchCondition from "@/components/h5/layout/SearchCondition.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import TableButtonGroup from "@/components/h5/button/TableButtonGroup.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import {useRoute, useRouter} from "vue-router";
import Util from "@/util/util";
import assemblyTemplateApi from "@/api/normal/stock/assemblyTemplateApi";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "MakeUpTemplateList",
  components: {
    YqTableColumn, TableButtonGroup, TableButton,
    SearchCondition, FormPage, ListTable, ListPage
  },
  data() {
    return {
      searchInfo: {pageNumber: 1},
      dataList: [],
    };
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  created() {
    this.resetSearch();
  },
  methods: {
    async queryList() {
      const {records, totalCount} = await assemblyTemplateApi.queryList(this.searchInfo);
      this.dataList = records;
      this.searchInfo.totalCount = totalCount;
    },
    resetSearch() {
      this.searchInfo.pageNumber = 1;
      this.queryList();
    },
    toDetail(row) {
      this.router.push(`/stock/makeUp/template/detail?id=${row.id}`);
    },
    async updateStatus(row) {
      const status = row.status === 1 ? 0 : 1;
      await assemblyTemplateApi.updateStatus(row.id, status);
      this.$message.success(status === 1 ? "已启用" : "已停用");
      this.resetSearch();
    },
    async toDelete(row) {
      await assemblyTemplateApi.delete(row.id);
      this.resetSearch();
    }
  }
};
</script>

<style lang="scss" scoped>
.make-up-template-list {
  height: 100%;
  .muted { color: var(--yq-font-color-desc); font-size: 12px; }
}
</style>
